import React from 'react';
import { Link } from "react-router-dom";
import * as util from "../other/util.js";
import * as ICONS from "../other/icons.js";
import * as Backend from "../backend.js";
import GlowPuzzle from './glow-puzzle.js';

class MenuTopView extends React.Component {
    constructor(props) {
        super(props);
        this.state = { gps: util.getGPS() };
    }

    componentDidMount() {
        util.subscribeGPS("top-game-menu", (gps) => this.onGpsUpdate(gps));
    }

    componentWillUnmount() {
        util.unsubscribeGps("top-game-menu");
    }

    onGpsUpdate(gps) {
        this.setState({ gps: gps });
    }

    render() {
        let gps = this.state.gps;
        if (!gps) {
            return (<util.LoadingBar thing={gps} thingName="gps" />);
        }

        let message_text = gps.unread_chat_count > 0 ? (<span>Messages <span className="link-news">({gps.unread_chat_count})</span></span>) : (<span>Messages</span>);
        let quest_text = gps.new_quest_count > 0 ? (<span>Quests <span className="link-news">({gps.new_quest_count})</span></span>) : (<span>Quests</span>);
        let planets = gps.planets;
        let planet_coord = planets.length > 0 ? planets[0].x + "/" + planets[0].y + "/" + planets[0].z : "0/0/0";
        let money_properties = [{ name: "Amount", value: gps.money, color: "white" }, { name: "Income", value: gps.money_hourly_production, color: "white" }];

        return (
            <div style={{
                backgroundImage: `url(${ICONS.PAGES.menu_background})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "100% 100%",
                backgroundColor: "green",
                paddingTop: "12px",
                height: "100px",
                width: "1000px"
            }}>
                <div style={{ display: "flex" }}>
                    <div style={{ flex: "40%", textAlign: "center" }}>
                        <span><util.PlayerLink playerName={gps.player_name} playerId={gps.player_id} /></span>
                        <span style={{ margin: "8px" }}>&#183;</span>
                        <span><Link className="link-button" to={{ pathname: '/game/ranking/overall', force_update: true }}>{gps.rank}.</Link></span>
                        <span> | </span>
                        <span><Link className="link-button" to={{ pathname: '/game/ranking/overall', force_update: true }}>{gps.points}p</Link></span>
                        <span style={{ margin: "8px" }}>&#183;</span>
                        <util.Tooltip tooltip={<util.ListInToolTip name={"Money"} properties={money_properties} />}>
                            <util.MoneyWithIcon resourceId="money" amount={gps.money} />
                        </util.Tooltip>
                        <span style={{ margin: "8px" }}>&#183;</span>
                        <span><div className="link-button" onClick={() => this.handleLogout()}>log out</div></span>
                    </div>
                    <div style={{ flex: "20%" }} >
                        <GlowPuzzle />
                    </div>
                    <div style={{ flex: "40%", textAlign: "center" }}>
                        <span><News news={gps.news} /></span>
                    </div>
                </div>
                <div style={{ paddingTop: "14px" }}>
                    <span style={{ marginLeft: "8px", marginRight: "8px" }} />
                    <Link className={"link-button-menu" + this.active("dashboard")} to={{ pathname: '/game/dashboard', force_update: true }}>Home</Link>
                    <span style={{ marginLeft: "8px", marginRight: "-2px" }}>&#183;</span>
                    <Link className={"link-button-menu" + this.active("ship-design-overview")} to={{ pathname: '/game/ship-design-overview', force_update: true }}>Ship Designs</Link>
                    <span style={{ marginLeft: "8px", marginRight: "-2px" }}>&#183;</span>
                    <Link className={"link-button-menu" + this.active("fleet-overview")} to={{ pathname: '/game/fleet-overview', force_update: true }}>Fleets</Link>
                    <span style={{ marginLeft: "8px", marginRight: "-2px" }}>&#183;</span>
                    <Link className={"link-button-menu" + this.active("chat-overview")} to={{ pathname: '/game/chat-overview', force_update: true }}>{message_text}</Link>
                    <span style={{ marginLeft: "8px", marginRight: "-2px" }}>&#183;</span>
                    <Link className={"link-button-menu" + this.active("quests")} to={{ pathname: '/game/quests/0', force_update: true }}>{quest_text}</Link>
                    <span style={{ marginLeft: "8px", marginRight: "-2px" }}>&#183;</span>
                    {this.renderResearchLink()}
                    <span style={{ marginLeft: "8px", marginRight: "-2px" }}>&#183;</span>
                    {gps.research.technologies["astronomy"] > 0
                        ? <Link className={"link-button-menu" + this.active("galaxy-browser")} to={{ pathname: '/game/galaxy-browser/' + planet_coord, force_update: true }}>Galaxy</Link>
                        : (<div className={"link-button-menu" + this.active("galaxy-browser")} style={{ color: "gray" }}>Galaxy</div>)}
                    <span style={{ marginLeft: "8px", marginRight: "-2px" }}>&#183;</span>
                    <Link className={"link-button-menu" + this.active("hq")} to={{ pathname: '/game/hq', force_update: true }}>HQ</Link>
                    <span style={{ marginLeft: "8px", marginRight: "-2px" }}>&#183;</span>
                    <Link className={"link-button-menu" + this.active("arc")} to={{ pathname: '/game/arc', force_update: true }}>The Arc</Link>
                </div>
            </div>
        );
    }

    renderResearchLink() {
        let gps = this.state.gps;

        if (gps.researcher_count <= 0) {
            return (<div className={"link-button-menu" + this.active("research")} style={{ color: "gray" }}>Research</div>);
        }
        if (gps.research.active_project) {
            return (<Link className={"link-button-menu" + this.active("research")} to={{ pathname: '/game/research', force_update: true }}>Research</Link>);
        }
        return (<Link className={"link-button-menu" + this.active("research")} to={{ pathname: '/game/research', force_update: true }} style={{ color: "green" }}>Research</Link>);
    }

    active(world) {
        const url = new URL(window.location.href).pathname;
        return url.includes("/game/" + world) ? " active" : "";
    }

    handleLogout() {
        Backend.logout(() => {
            this.props.navigate('/');
        });
    }
}

class News extends React.Component {
    render() {
        let news = this.props.news;
        switch (news.type) {
            case "TEXT":
                return (<span>News: {news.text}</span>);
            case "NEW_PLAYER":
                return (<span>News: <util.PlayerLink playerId={news.player_id} playerName={news.player_name} /> has arrived in this galaxy.</span>);
            default:
                return (<span>{JSON.stringify(news)}</span>);
        }
    }
}

export default util.withNavigation(MenuTopView);
